import { marker } from '@jsverse/transloco-keys-manager/marker';
import { TelemonitoringRequestForm } from '@modules/telemonitoring/telemonitoring-request/telemonitoring-request-form';

export const defaultReminderDaysInterval = 7;

export const telemonitoringRequestStepsConfig: {
  name: string;
  hidePrevious?: boolean;
  hideNext?: boolean;
  fields?: (keyof TelemonitoringRequestForm)[];
}[] = [
  {
    name: marker('Type'),
    hideNext: true,
    fields: ['creatorType'],
  },
  {
    name: marker('Emplacement'),
    fields: ['clientCode', 'departmentIds'],
  },
  {
    name: marker('Détails'),
    fields: [
      'name',
      'message',
      'localeCode',
      'patientForm',
      'patientContact',
      'shouldSendTextMessageToPatient',
      'enableAutomaticReminderForInactivePatient',
    ],
  },
  {
    name: marker('Photos'),
    fields: ['sequences'],
  },
  {
    name: marker('Collaboration'),
    fields: ['collaborators'],
  },
];
